<template>
    <div>
      <a
        class="mr-2 cursor-pointer"
        data-toggle="modal"
        data-target="#threatPathModal"
        @click="$parent.$parent.$parent.getThreatPath(data)"
        :class="options.class"
      >
        <p v-if="data.path.length > 0">
          {{ data.path.length }} {{ data.path.length === 1 ? "Path" : "Paths" }}
        </p>
      </a>
    </div>
  </template>
  
  <script>
  export default {
    name: "ThreatPath",
    props: {
      data: {
        type: Object,
        default: () => ({}),
      },
      options: {
        type: Object,
        default: () => ({}),
      },
    },
  };
  </script>
  